import { render } from "./MessageComponent.vue?vue&type=template&id=5274304a&scoped=true"
import script from "./MessageComponent.vue?vue&type=script&lang=js"
export * from "./MessageComponent.vue?vue&type=script&lang=js"

import "./MessageComponent.vue?vue&type=style&index=0&id=5274304a&scoped=true&lang=css"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5274304a"]])

export default __exports__